import { jsx as t, jsxs as h } from "react/jsx-runtime";
import { forwardRef as x } from "react";
import C from "./CloseRounded.mjs";
import { Slide as S, useMediaQuery as R, Dialog as T, IconButton as B } from "@mui/material";
import { TEST_IDS as _ } from "./testIds.mjs";
import { MOBILE_SMALL_SCREEN as v } from "./screens.mjs";
import { useStennTheme as E } from "./useStennTheme.mjs";
import { DialogContext as M } from "./context.mjs";
const y = x(function(i, r) {
  return /* @__PURE__ */ t(
    S,
    {
      direction: "up",
      ref: r,
      timeout: 400,
      easing: {
        enter: "cubic-bezier(0.41, 1, 0.62, 1)",
        exit: "cubic-bezier(0.41, 1, 0.62, 1)"
      },
      ...i
    }
  );
}), q = ({
  shouldCloseOnBackDropClick: l = !0,
  hasCloseIcon: i = !0,
  handleClose: r,
  onClose: d,
  children: m,
  open: p,
  testId: c = _.dialog,
  isDrawerLike: e = !1,
  fullWidth: u,
  ...g
}) => {
  const n = E(), a = R(n.breakpoints.down(v)), s = () => {
    d?.(), r?.();
  }, f = (o, b) => {
    (l || b !== "backdropClick") && s();
  };
  return /* @__PURE__ */ t(M.Provider, { value: { isDrawerLike: e }, children: /* @__PURE__ */ h(
    T,
    {
      TransitionComponent: y,
      fullWidth: u,
      fullScreen: e && a,
      open: p,
      onClose: f,
      "data-testid": c,
      PaperProps: {
        square: !(e && a),
        sx: {
          borderRadius: "16px",
          border: "1px solid",
          borderColor: (o) => o.palette.other.divider,
          display: "flex",
          flexDirection: "columns",
          rowGap: "24px",
          paddingTop: n.spacing(3),
          paddingBottom: n.spacing(3),
          ...e && a ? {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            height: "auto",
            alignSelf: "flex-end",
            marginRight: 0,
            marginLeft: 0,
            marginBottom: 0,
            maxHeight: "85%"
          } : {}
        }
      },
      ...g,
      children: [
        i && /* @__PURE__ */ t(
          B,
          {
            onClick: s,
            size: "medium",
            sx: {
              position: "absolute",
              top: (o) => o.spacing(2),
              right: (o) => o.spacing(3),
              color: (o) => o.palette.grey[500]
            },
            children: /* @__PURE__ */ t(C, {})
          }
        ),
        m
      ]
    }
  ) });
};
export {
  q as Dialog
};
//# sourceMappingURL=index29.mjs.map
